import React, { useState } from 'react'
import { Form, Icon, Input, Modal, Row, Select, Upload, Radio, Col, Button } from 'antd'
import axios from 'axios'
import { ButtonEx } from '../../../../styles/button.style'
import UploadImages from '../../../../components/UploadImages'
import { useDeepEffect } from '../../../../utils/hooks'
import { UNIT } from '../../../../utils/constants'
import _, { isNull } from 'lodash'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'

const EquipmentForm = (props) => {
  const { visible, onOk, onCancel, formData, form, seller } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form
  const [equipmentImageUrl, setEquipmentImageUrl] = useState("")
  const [categories, setCategories] = useState([])
  const [coverList, setCoverList] = useState([])
  const [equipmentId, setEquipmentId] = useState(0)
  const [subCategories, setSubCategories] = useState([]);

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        detail: formData.detail,
        price: formData.price,
        category: formData.subEquipment.category.id,
        subEquipment: formData.subEquipment.id,
        seller: formData.seller.id,
      })
      setEquipmentImageUrl(formData.cover.url)
      fetchCoverList(formData.id)
      setEquipmentId(formData.id)
      fetchSubCategories(formData.subEquipment.category.id)
    }
    fetchCategories()
    return () => {
      form.resetFields()
      setEquipmentImageUrl('')
    }
  }, [formData])

  console.log(subCategories)

  async function fetchCategories() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/categoryDetail/all`
      )
      setCategories(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  async function fetchSubCategories(id) {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/subCategory/${id}`
      )
      setSubCategories(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  async function fetchCoverList(id) {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/coverList/${id}`
      )
      setCoverList(res.data.productImages)
    } catch (err) {
      console.log(err)
    }
  }

  async function uploadEquipmentImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/equipment/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
          }
        }
      )
      return res.data
    } catch (err) {
      return null
    }
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  const handleSelectedSubCategories = (subCategories) => {
    setFieldsValue( {
      subEquipment: null
    })
    setSubCategories([])
    fetchSubCategories(subCategories)
  }


  async function handleChange(info) {
    await getBase64(info.file, (ImageUrl) => {
      setEquipmentImageUrl(ImageUrl)
    })
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          detail: values.detail,
          price: values.price,
          category: values.category,
          subEquipmentId: values.subEquipment,
          sellerId: values.seller,
        }
        if (values.equipmentImage) {
          const img = await uploadEquipmentImage(values.equipmentImage.file)
          data.cover = img.id
        } else {
          data.cover = formData.cover.id
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
        setEquipmentImageUrl('')
      }
    })
  }

  async function handleRemoveEquipmentImage(imgId) {
    try {
      const userToken = localStorage.getItem('user-token')
      const formData = new FormData()
      formData.append('imgId', imgId)
      formData.append('equipmentId', equipmentId)
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/equipment/deleteCoverList`,
        formData,
        {
          headers: {
            Authorization: userToken,
          }
        }
      )
      fetchCoverList(equipmentId)
    } catch (error) {
      console.log(error.message)
    }
  }

  async function handleUploadEquipmentImage(file) {
    try {
      const userToken = localStorage.getItem('user-token')
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      formData.append('equipmentId', equipmentId)
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/equipment/coverList`,
        formData,
        {
          headers: {
            Authorization: userToken,
            'content-type': 'multipart/form-data',
          }
        }
      )
      fetchCoverList(equipmentId)
    } catch (error) {
      console.log(error.message)
    }
  }

  return (
    <Modal
      visible={visible}
      title={`${!_.isEmpty(formData) ? 'Edit ' : 'Create a new '} equipment`}
      footer={null}
      onCancel={onCancel}
    >
      <Form onSubmit={onSubmit}>
        <Form.Item label="รูปหน้าปก">
          <Row type="flex" justify="center">
            <Col>
              {getFieldDecorator(`equipmentImage`, {
                rules: [
                  {
                    required: isNull(formData),
                    message: 'เลือกรูปภาพ'
                  }
                ]
              })(
                <Upload
                  name="img"
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={(file) => beforeUpload(file)}
                  onChange={handleChange}
                >
                  {equipmentImageUrl ? (
                    <img src={equipmentImageUrl} alt="img" style={{ width: '100%' }} />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              )}
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="ชื่อวัสดุรีไซเคิล">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="ชื่อเครื่องจักรอุปกรณ์" />)}
        </Form.Item>

        <Form.Item label="รายละเอียด">
          {getFieldDecorator(`detail`)
            (<Input.TextArea
              name="detail"
              placeholder="รายละเอียด" />)}
        </Form.Item>

        <Form.Item label="ราคา">
          {getFieldDecorator(`price`)
            (<Input
              name="price"
              placeholder="ราคา" />)}
        </Form.Item>

        <Form.Item label="วัสดุหลัก">
          {getFieldDecorator(`category`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Select
              placeholder="เลือกวัสดุหลัก"
              name="category"
              onChange={(e) => handleSelectedSubCategories(e)}
            >
              {categories.map(category => (
                <Select.Option key={category.id} value={category.id}>
                  {category.name}
                </Select.Option>
              ))}
            </Select>)}
        </Form.Item>
        <Form.Item label="วัสดุรอง">
          {getFieldDecorator(`subEquipment`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Select
              placeholder="เลือกวัสดุรอง"
              name="subEquipment"
              allowClear
            >
              {subCategories && subCategories.map(subCategories => (
                <Select.Option key={subCategories.name} value={subCategories.id}>
                  {subCategories.name}
                </Select.Option>
              ))}
            </Select>)}
        </Form.Item>
        <Form.Item label="ผู้ขาย">
          {getFieldDecorator(`seller`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Select
              placeholder="เลือกผู้ขาย"
              name="seller"
            >
              {seller.map(seller => (
                <Select.Option key={seller.name} value={seller.id}>
                  {seller.name}
                </Select.Option>
              ))}
            </Select>)}
        </Form.Item>

        {formData && (
          <Form.Item label="Pictures">
            <UploadImages
              uploadImage={handleUploadEquipmentImage}
              removeImage={handleRemoveEquipmentImage}
              images={coverList || null}
            />
          </Form.Item>
        )}
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              {`${!_.isEmpty(formData) ? 'Save ' : 'Create'}`}
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedEquipmentForm = Form.create({
  name: 'EquipmentForm'
})(EquipmentForm)
export default (WrappedEquipmentForm)



// WEBPACK FOOTER //
// ./src/pages/Equipment/components/EquipmentForm/index.js